import {
    Component,
    computed,
    inject,
    ChangeDetectionStrategy,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IonBadge } from '@ionic/angular';
import { CartService } from '../../../services/cart.service';
import { LoggerService } from '../../../services/logger.service';

@Component({
    selector: 'app-header-cart-status',
    templateUrl: './header-cart-status.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IonBadge, RouterLink, RouterLinkActive],
})
export class HeaderCartStatusComponent {
    private _cart = inject(CartService);
    private _logger = inject(LoggerService);
    private _cartItems = this._cart.cartItems.asReadonly();

    count = computed(() => {
        this._logger.debug('HeaderCartStatusComponent -- computing cart count');
        return (
            this._cartItems()?.reduce((acc, cur) => acc + cur.quantity, 0) ?? 0
        );
    });
}
